import { VariantProps, cva } from 'class-variance-authority';

export const cardListStyles = cva('bg-grayscale0 rounded-12', {
  variants: {
    variant: {
      outlined: 'border border-grayscale100',
      elevated: 'shadow-1',
    },
    padding: {
      12: 'p-12',
    },
  },
  defaultVariants: {
    variant: 'outlined',
  },
});

export type CardListStylesVariants = VariantProps<typeof cardListStyles>;
